import styled from '@emotion/styled';

export const LoadingMessageWrapper = styled.div`
  font-size: 1.4em;
  color: var(--color-font-primary);
`;
